import { CreateAnAccountBtn } from "../CreateAnAccountBtn";

export const InviteToISN = () => {
  return (
      <div className="flex flex-col self-stretch justify-start flex-grow-0 flex-shrink-0 mt-10 overflow-hidden bg-white border-t border-lineMid dark:border-lineLight">
        <CreateAnAccountBtn icon={true} helperText={"You can invite this user to also start using the app"} />
      </div>
  );
};
